export default __webpack_public_path__ + "static/media/hair-5-6.fed44983.svg";